import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { FaThLarge, FaFolderOpen, FaSignOutAlt, FaExclamationTriangle, FaConciergeBell, FaShareAlt, FaEnvelopeOpenText, FaInfoCircle, FaLock, FaGavel, FaCookieBite, FaHeadset, FaFileInvoiceDollar } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import toast from 'react-hot-toast';
import logo from '../assets/logo.png';
import './Sidebar.css';

const Sidebar = () => {
    const navigate = useNavigate();
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('admin_token');
        toast.success('Logged out successfully');
        navigate('/admin/login');
    };

    return (
        <>
            <div className="admin-sidebar">
                <div className="sidebar-brand">
                    <img src={logo} alt="Nimai Admin" />
                    <span>Admin Panel</span>
                </div>

                <nav className="sidebar-nav">
                    <NavLink to="/admin/dashboard" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaThLarge className="nav-icon" />
                        <span>Dashboard</span>
                    </NavLink>
                    <NavLink to="/admin/invoice" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaFileInvoiceDollar className="nav-icon" />
                        <span>Generate Invoice</span>
                    </NavLink>
                    <NavLink to="/admin/services" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaConciergeBell className="nav-icon" />
                        <span>Services</span>
                    </NavLink>
                    <NavLink to="/admin/portfolio" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaFolderOpen className="nav-icon" />
                        <span>Portfolio</span>
                    </NavLink>
                    <NavLink to="/admin/socials" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaShareAlt className="nav-icon" />
                        <span>Social Links</span>
                    </NavLink>
                    <NavLink to="/admin/inquiries" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaEnvelopeOpenText className="nav-icon" />
                        <span>Inquiries</span>
                    </NavLink>
                    <NavLink to="/admin/contact-page" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaHeadset className="nav-icon" />
                        <span>Contact Page</span>
                    </NavLink>
                    <NavLink to="/admin/about" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaInfoCircle className="nav-icon" />
                        <span>Manage About</span>
                    </NavLink>
                    <NavLink to="/admin/privacy" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaLock className="nav-icon" />
                        <span>Privacy Policy</span>
                    </NavLink>
                    <NavLink to="/admin/terms" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaGavel className="nav-icon" />
                        <span>Terms & Conditions</span>
                    </NavLink>
                    <NavLink to="/admin/cookies" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                        <FaCookieBite className="nav-icon" />
                        <span>Cookie Policy</span>
                    </NavLink>
                </nav>

                <div className="sidebar-footer">
                    <button className="logout-btn" onClick={() => setShowLogoutConfirm(true)}>
                        <FaSignOutAlt /> <span>Logout</span>
                    </button>
                </div>
            </div>

            {/* Logout Confirmation Modal */}
            <AnimatePresence>
                {showLogoutConfirm && (
                    <motion.div
                        className="modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="logout-modal"
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                        >
                            <div className="modal-icon">
                                <FaExclamationTriangle />
                            </div>
                            <h3>Are you sure?</h3>
                            <p>You are about to sign out of the Admin Portal. Any unsaved changes might be lost.</p>

                            <div className="modal-actions">
                                <button className="modal-btn-cancel" onClick={() => setShowLogoutConfirm(false)}>
                                    Cancel
                                </button>
                                <button className="modal-btn-confirm" onClick={handleLogout}>
                                    Yes, Logout
                                </button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default Sidebar;
